/* tslint:disable */
/* eslint-disable */
export enum BankStatementSourceEnum {
  IllionBrokerFlow = 'IllionBrokerFlow',
  ProvideLater = 'ProvideLater',
  SendLink = 'SendLink'
}
